import './App.css';
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home';
import Itinerary from './components/pages/Itinerary';
import Login from './components/pages/Login';
import AdminDashboard from './components/pages/AdminDashboard';
import { LanguageProvider } from './context/LanguageContext';

import GuestLogin from './components/pages/GuestLogin';
import RSVPGuest from './components/pages/RSVPGuest';
import Gifts from './components/pages/Gifts';
import Success from './components/pages/Success';


function App() {
  const [guest, setGuest] = useState(() => {
    // Clear out old localStorage data if it exists to prevent stale data lingering
    localStorage.removeItem('guest');

    // Try to load guest from sessionStorage for persistence
    const stored = sessionStorage.getItem('guest');
    if (stored) {
      const parsed = JSON.parse(stored);
      // Validate: if name or allowedGuests is missing, data is stale - force re-login
      if (!parsed.name || !parsed.allowedGuests) {
        sessionStorage.removeItem('guest');
        return null;
      }
      return parsed;
    }
    return null;
  });

  useEffect(() => {
    if (guest) {
      sessionStorage.setItem('guest', JSON.stringify(guest));
    } else {
      sessionStorage.removeItem('guest');
    }
  }, [guest]);

  // Guest-only route protection
  const requireGuest = (Component) =>
    guest ? <Component guest={guest} /> : <GuestLogin onLogin={g => setGuest(g)} />;

  return (
    <LanguageProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/confirmar' exact element={requireGuest(RSVPGuest)} />
          <Route path='/regalos' exact element={<Gifts />} />
          <Route path='/itinerario' exact element={<Itinerary />} />
          <Route path='/login' exact element={<Login />} />
          <Route path='/admin' exact element={<AdminDashboard />} />
          <Route path='/invitado' exact element={<GuestLogin onLogin={g => setGuest(g)} />} />
          <Route path='/rsvp-invitado' exact element={requireGuest(RSVPGuest)} />
          <Route path='/success' exact element={<Success />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
